import React from 'react';
import m from './TemplatePickerMobile.module.css';
import s from '../DietPlanBuilder.module.css';
import { Chip, Pill } from '../ui';
import { copy } from '../../copy';
import { MACRO_META_NATIVE } from './goalsStep.shared';
import type { TemplateCardView } from '../../hooks/useTemplatePicker';
import type { Template } from '../../types';

export function TemplatePickerMobile({
  filters,
  filter,
  onFilter,
  cards,
  loading,
  onPick,
}: {
  filters: string[];
  filter: string;
  onFilter: (f: string) => void;
  cards: TemplateCardView[];
  loading: boolean;
  onPick: (t: Template | null) => void;
}) {
  return (
    <div className={m.page}>
      <div className={s.chipRow} style={{ padding: '14px 20px 4px' }} role="tablist" aria-label="Template filters">
        {filters.map(f => (
          <Chip key={f} on={filter === f} onClick={() => onFilter(f)}>{f}</Chip>
        ))}
      </div>

      <div className={m.list}>
        {loading && <div className={m.muted}>Loading templates…</div>}
        {!loading && cards.map(({ t, kcal, split, meta, suggested, mine }) => (
          <button type="button" key={String(t.id)} className={m.card} onClick={() => onPick(t)}>
            <div className={m.cardTop}>
              <div className={m.name}>{t.name}</div>
              {suggested && <Pill tone="green">{copy.tpl.suggested}</Pill>}
              {mine && <Pill tone="amber">{copy.tpl.mine}</Pill>}
            </div>
            <div className={m.kcalRow}>
              <span className={m.kcal}>{kcal}</span>
              <span className={m.kcalUnit}>{copy.tpl.perDay}</span>
              <span className={m.rule} aria-hidden />
              <span className={m.split}>{split}</span>
            </div>
            <div className={m.bar} aria-hidden>
              <span style={{ width: `${t.pct.p}%`, background: MACRO_META_NATIVE.p.bg }} />
              <span style={{ width: `${t.pct.c}%`, background: MACRO_META_NATIVE.c.bg }} />
              <span style={{ width: `${t.pct.f}%`, background: MACRO_META_NATIVE.f.bg }} />
            </div>
            <div className={m.meta}>{meta}</div>
          </button>
        ))}
        {!loading && !cards.length && <div className={m.muted}>No templates found</div>}
        <button type="button" className={s.btnDashed} style={{ marginTop: 6, width: '100%' }} onClick={() => onPick(null)}>
          {copy.tpl.blank}
        </button>
      </div>
    </div>
  );
}
